import React from 'react';
import { CardFull } from '../../widgets/Cards';
import Glucometer from './HomeCheck/Glucometer';
import Weight from './HomeCheck/Weight';
import BloodPressure from './HomeCheck/BloodPressure';

class HomeCheck extends React.Component {
    render() {
        return (
            <CardFull  title='Home Monitoring'>
                <Glucometer />
                <Weight />
                <BloodPressure />
            </CardFull>
        )
    }



}

export default HomeCheck;